import { Button } from "antd";

const ButtonComp = ({ title, url, classStyle, customStyle }) => {
	return (
		<Button
			className={classStyle}
			shape="round"
			type="link"
			href={url}
			variant="link"
			style={{customStyle}}
		>
			{title}
		</Button>
	)
}

export default ButtonComp